/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

// tslint:disable:variable-name

import { ID, WithVersion } from '@gh/common-shared-data';
import { createEnum, EnumSet, WithOptimisticLock } from '@gh/core-data';

export const LicenseAgreementType = createEnum('LICENSE_AGREEMENT_TYPE', {
  Franchisee: 1,
  Other: 2,
});

export type LicenseAgreementType = EnumSet<typeof LicenseAgreementType>;

export type LicenseAgreementListItemDto = {
  id: ID;
  name: string;
  systemRole: LicenseAgreementType;
  active: boolean;
};

export type LicenseAgreementDetailsDto = WithOptimisticLock<{
  id: ID;
  name: string;
  description: string;
  isActive: boolean;
  systemRole: LicenseAgreementType;
  eula: string;
  confirmations: {
    skipRelevanceCheck: boolean;
  };
}>;

export type UserLicenseAgreementDto = WithVersion<{
  agreementId: ID;
  eula: string;
  accepted: boolean;
}>;
